import type { MetaPixelItem } from './interfaces'

import { MetaPixelName } from './enums'

export const metaPixelSdkUrl = 'https://connect.facebook.net/en_US/fbevents.js'

export const metaPixels: MetaPixelItem[] = [
  { name: MetaPixelName.Hiring, pixelId: '1558367781895442' },
  { name: MetaPixelName.ReachPurchase, pixelId: '764032611536763' },
]
